// extracted by mini-css-extract-plugin
export default {"tableWorkingArea":"UploadCsv_tableWorkingArea__ICYeu"};